import React from "react";
import { withState, compose, getContext } from "recompose";
import styled from "styled-components";
import PropTypes from "prop-types";
import { connect } from "react-firebase";
import TextField from "material-ui/TextField";
import RaisedButton from "material-ui/RaisedButton";
import Checkbox from "material-ui/Checkbox";
import SelectField from "material-ui/SelectField";
import MenuItem from "material-ui/MenuItem";
import TransitionChildren from "../common/TransitionChildren";
import Loading from "../common/Loading";

const LoginStyles = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 70%;

  button {
    margin-top: 24px;
  }

  button[disabled] {
    opacity: 0.3;
  }

  h3 {
    color: whitesmoke;
  }
`;

const LoginButton = styled.button`
  color: SNOW;
  margin: 10px;
  padding: 8px 12px;
  font-size: 16px;
  background: none;
  border: 1px solid SNOW;
`;

function Login(props) {
  const {
    loginUser,
    email,
    setEmail,
    otherField,
    setOtherField,
    loading,
    list = {},
    subscribed,
    setSubscribed,
    selector,
    path,
    submitAttempted,
    setSubmitAttempted
  } = props;

  const isValidEmail = /^\S+@\S+$/.test(email) && otherField;

  function doLogin(opts) {
    if (isValidEmail) {
      loginUser(opts);
      return;
    }

    setSubmitAttempted(true);
  }

  return (
    <TransitionChildren transitionClass="out" className="fade">
      {loading ? (
        <Loading key="loading" />
      ) : (
        <LoginStyles key="login">
          <h3>Sign Up</h3>
          <TextField
            hintText="Your email"
            floatingLabelText="Email"
            onChange={(evt, val) => setEmail(val)}
            value={email}
          />
          <SelectField
            floatingLabelText={selector}
            value={otherField}
            onChange={(evt, index, val) => setOtherField(val)}
          >
            {Object.keys(list).map(id => (
              <MenuItem key={id} value={id} primaryText={list[id].name} />
            ))}
          </SelectField>
          <div style={{ width: 256, paddingTop: 32 }}>
            <Checkbox
              checked={subscribed}
              onCheck={(evt, isChecked) => setSubscribed(isChecked)}
              label="I would like to receive emails about mystic perks."
            />
          </div>
          <LoginButton
            onClick={evt =>
              doLogin({
                email,
                [selector.toLowerCase()]:
                  list[otherField] && list[otherField].name,
                subscribed
              })}
          >
            Login
          </LoginButton>
          {!isValidEmail && submitAttempted ? (
            <p>Enter an email and choose a {selector.toLowerCase()}.</p>
          ) : null}
        </LoginStyles>
      )}
    </TransitionChildren>
  );
}

const LoginContainer = compose(
  getContext({
    selector: PropTypes.string,
    path: PropTypes.string
  }),
  connect((props, ref, firebase) => {
    return { list: props.path };
  }),
  withState("submitAttempted", "setSubmitAttempted", false),
  withState("loading", "setLoading", false),
  withState("subscribed", "setSubscribed", true),
  withState("email", "setEmail", ""),
  withState("otherField", "setOtherField", "")
)(Login);

export default LoginContainer;



// WEBPACK FOOTER //
// ./src/user/Login.js